/*
 * ra-apple-fade-in.js
 * -----------------------------------------------------------------------------
 * Scroll-triggered fade-in for elements with class `.ra-fade-in`.
 * Adds `.is-visible` as the element enters the viewport; CSS handles the
 * opacity/transform transition.
 *
 * Safe to load from multiple sections — guarded against double init via
 * window.__raAppleFadeInInit. Also uses a MutationObserver so sections that
 * add .ra-fade-in content after initial load (dynamic blocks, AJAX) are
 * still animated.
 */
(function () {
  if (window.__raAppleFadeInInit) return;
  window.__raAppleFadeInInit = true;

  function observeEl(observer, el) {
    if (el.classList.contains('is-visible')) return;
    observer.observe(el);
  }

  function initFadeIn() {
    var targets = document.querySelectorAll('.ra-fade-in:not(.is-visible)');
    if (!targets.length && !document.body) return;

    if (!('IntersectionObserver' in window)) {
      // Fallback: just mark everything visible so content isn't invisible.
      for (var i = 0; i < targets.length; i++) {
        targets[i].classList.add('is-visible');
      }
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -10% 0px' });

    for (var j = 0; j < targets.length; j++) {
      observeEl(observer, targets[j]);
    }

    // Watch for elements added to the DOM later (e.g. AJAX-rendered blocks
    // or Shopify theme editor re-renders while editing a section).
    if ('MutationObserver' in window) {
      var mo = new MutationObserver(function (mutations) {
        mutations.forEach(function (m) {
          m.addedNodes.forEach(function (node) {
            if (!(node instanceof Element)) return;
            if (node.classList && node.classList.contains('ra-fade-in')) {
              observeEl(observer, node);
            }
            var inner = node.querySelectorAll && node.querySelectorAll('.ra-fade-in:not(.is-visible)');
            if (inner && inner.length) {
              for (var k = 0; k < inner.length; k++) {
                observeEl(observer, inner[k]);
              }
            }
          });
        });
      });
      mo.observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFadeIn);
  } else {
    initFadeIn();
  }
})();
